// 线索管理
const clueManage = {
  state: {
    treeData: [], // 轮次届次单位树
    treeRow:'', // 树的行
    treeRowKeyId:'',// 树的行虚拟id
    treeRowOid: '', // 树的行oid
    screenStart: true, // 是否开屏模式
    
    inspectionMethod: '1', // 方式
  },
  mutations: {
    setClueTreeData(state, value) {
      state.treeData = value
    },
    setClueTreeRow(state, value) {
      state.treeRow = value
    },
    setClueTreeRowKeyId(state, value) {
      state.treeRowKeyId = value
    },
    setClueTreeRowOid(state, value) {
      state.treeRowOid = value
    },
    setClueScreenStart(state, value) {
      state.screenStart = value
    },
    setClueInspection(state, value) {
      state.inspectionMethod = value
    }
  }
};
export default clueManage;



// WEBPACK FOOTER //
// ./src/store/modules/clueManage.js